import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { VERSION } from "@core/version";
import { CacheId } from "@shared/enums";

@Injectable({
  providedIn: "root",
})
export class VersionsService {
  private http = inject(HttpClient);
  private appVersion = VERSION;

  getVersions(): Observable<any> {
    const storedVersions = localStorage.getItem(CacheId.Versions);

    if (storedVersions) {
      const parsedVersions = JSON.parse(storedVersions);

      if (parsedVersions.appVersion === this.appVersion) {
        return of(parsedVersions.versions); // Return an observable of the data if it matches the current app version
      } else {
        localStorage.removeItem(CacheId.Versions);
      }
    }

    return this.createAndStoreVersions();
  }

  private createAndStoreVersions(): Observable<any> {
    return this.http.get("./assets/data/version-details.json").pipe(
      map((data) => {
        const newVersions = {
          appVersion: this.appVersion,
          versions: (data as any[]).reverse(),
        };
        localStorage.setItem(CacheId.Versions, JSON.stringify(newVersions));
        return newVersions.versions;
      }),
      catchError((error) => {
        // Handle potential errors, such as network issues or JSON parsing errors
        console.error("Failed to load version details", error);
        return of([]); // Return an empty array or appropriate fallback
      })
    );
  }
}
